import { ButtonInputWithPopover } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { Agreement } from "../../../../clients/graphqlTypes.js";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../../commons/filters/FilterChip.js";
import { FilterProps } from "../../../commons/filters/index.js";
import { useQuoteAcceptanceTypes } from "../useAcceptanceTypes.js";

export function QuotesAcceptanceFilterButton(props: FilterProps<Agreement[]>) {
  const { t } = useTranslate(["QuoteFilter"]);
  const { acceptanceTypeOptions } = useQuoteAcceptanceTypes();

  return (
    <ButtonInputWithPopover
      label={t("Acceptance", { ns: "QuoteFilter" })}
      counter={
        props.value &&
        props.value.length > 0 &&
        props.value.length < acceptanceTypeOptions.length
          ? props.value.length
          : undefined
      }
      content={<QuotesAcceptanceFilterForm {...props} />}
      popoverWidth="md"
    />
  );
}

function QuotesAcceptanceFilterForm({
  value,
  setValue,
}: FilterProps<Agreement[]>) {
  const { acceptanceTypeOptions } = useQuoteAcceptanceTypes();

  return (
    <Box p={1}>
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          {acceptanceTypeOptions.map((option, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={value.includes(option.value)}
                  onChange={(_event, checked) => {
                    if (checked) {
                      setValue(Array.from(new Set([...value, option.value])));
                    } else {
                      setValue(value.filter(v => v !== option.value));
                    }
                  }}
                />
              }
              label={<Typography variant="body1">{option.label}</Typography>}
              sx={{ ml: 0, mr: 0 }}
              key={`${option.value}-${index}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export function QuotesAcceptanceFilterChips(
  props: Omit<FilterChipGroupProps<Agreement>, "label" | "getValueLabel">
) {
  const { t } = useTranslate("QuoteFilter");
  const { acceptanceTypeLabels } = useQuoteAcceptanceTypes();

  return (
    <FilterChipGroup
      label={t("Acceptance", { ns: "QuoteFilter" })}
      setValues={props.setValues}
      values={props.values}
      getValueLabel={value => acceptanceTypeLabels[value]}
    />
  );
}
